import moment from 'moment';
import {
  decodeDelimitedArray,
  decodeDelimitedNumericArray,
  encodeDelimitedArray,
  encodeDelimitedNumericArray,
} from 'use-query-params';
import { convertToMT, safeJsonParse } from './Helper';

export function getDisplayStatus(d) {
  return d.allocatedQty >= 0 && ['APPROVED', 'CREATED'].includes(d.status)
    ? d.allocatedQty === 0
      ? 'UNALLOCATED'
      : d.allocatedQty < d.qty
        ? 'PARTIALLY_ALLOCATED'
        : 'ALLOCATED'
    : d.status;
}

export function getNewDisplayStatus(d) {
  return d.allocatedQty >= 0 && ['APPROVED', 'CREATED'].includes(d.status)
    ? d.allocatedQty === 0
      ? 'AUTO_ALLOCATION'
      : d.allocatedQty < d.qty
        ? 'PARTIALLY_ALLOCATED'
        : areMandatoryCertificatesUploaded(d)
          ? d.status
          : 'CERTIFICATE_GENERATION'
    : d.status;
}

const areMandatoryCertificatesUploaded = (d) => {
  if ('deliveryDocuments' in d) {
    const certificateDocuments = d?.deliveryDocuments.filter(
      (doc) => doc.document.type.includes('CERTIFICATE') || doc.document.type.includes('ULB')
    );
    if (
      d?.assignedToWoItem?.browseNodeId === '1' ||
      d?.assignedToWoItem?.browseNodeId === '4' ||
      d?.assignedToWoItem?.browseNodeId === '6'
    ) {
      return certificateDocuments.some((doc) =>
        doc.document.type.includes('CERTIFICATE_OF_RECYCLING')
      );
    } else if (d?.assignedToWoItem?.browseNodeId === '2') {
      return certificateDocuments.some((doc) =>
        doc.document.type.includes('CO_PROCESSING_CERTIFICATE')
      );
    } else return false;
  } else return false;
};

export function getInvoiceDisplayStatus(cellInfo) {
  let displayStatus = '';
  if (cellInfo?.draft) {
    displayStatus = 'DRAFT';
  } else if (
    //cellInfo.status === 'APPROVED' &&
    Number(parseFloat(cellInfo.balanceAmount).toFixed(2)) > 0 &&
    cellInfo.balanceAmount < cellInfo.amount
  ) {
    displayStatus = 'PARTIALLY_PAID';
  } else if (
    //cellInfo.status === 'APPROVED' &&
    Number(parseFloat(cellInfo.balanceAmount).toFixed(2)) === 0
  ) {
    displayStatus = 'PAID';
  } else {
    displayStatus = cellInfo.status;
  }

  return displayStatus;
}

export const saveFile = (data, filename) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename); //or any other extension
  link.click();
};

export const roundOffAmount = (amount) => {
  return Number(parseFloat(amount || 0).toFixed(2));
};

export const trimAmount = (num, precision = 2) => {
  const multiplier = 10 ** precision;
  return Math.trunc(Number(num) * multiplier) / multiplier;
};

/** Uses a comma to delimit entries. e.g. ['a', 'b'] => qp?=a,b */
export const CommaArrayParam = {
  encode: (array = undefined) => encodeDelimitedArray(array, ','),

  decode: (arrayStr = undefined) => decodeDelimitedArray(arrayStr, ','),
};

/** Uses a comma to delimit entries. e.g. ['a', 'b'] => qp?=a,b */
export const CommaArrayNumberParam = {
  encode: (array = undefined) => encodeDelimitedNumericArray(array, ','),

  decode: (arrayStr = undefined) => decodeDelimitedNumericArray(arrayStr, ','),
};

export function timeConvert(n) {
  var num = n;
  var hours = num / 60;
  var rhours = Math.floor(hours);
  var minutes = (hours - rhours) * 60;
  var rminutes = Math.round(minutes);
  return rhours + 'hr' + rminutes + 'm';
}

export async function extractAddressResponse(geoCodeResponse, lat, lng) {
  const addr = {
    cityName: '',
    latLng: { lat: '', lng: '' },
    sourceName: '',
    sourceType: '',
    state: { name: '' },
    street: '',
    zipCode: '',
  };
  addr.latLng.lat = lat;
  addr.latLng.lng = lng;
  geoCodeResponse[0].address_components.forEach((item) => {
    if (item.types.includes('postal_code')) {
      addr.zipCode = item.long_name;
    }
    if (item.types.includes('locality')) {
      addr.cityName = item.long_name;
    }
    if (item.types.includes('administrative_area_level_1')) {
      addr.state.name = item.long_name;
    }
  });
  // const toRemove = [addr.city, addr.state, addr.zipCode, addr.country];
  addr.streetAddress = geoCodeResponse[0]?.formatted_address;

  return addr;
}
export const formatIndianNumber = (number, minimumFractionDigits = 0) => {
  if (number) {
    let numstr = Number(number);
    return new Intl.NumberFormat('en-IN', {
      style: 'decimal',
      // currency: 'INR',
      minimumFractionDigits,
    }).format(numstr);
  } else {
    return '';
  }
};

export const roundQuantitiesGreaterThanCutoff = (val, cutoff = 1) => {
  if (+val < cutoff) {
    return formatIndianNumber(getDecimalValue(val));
  }
  return formatIndianNumber(Math.round(val));
};

export const formatIndianNumberWithoutDecimals = (num) => {
  const intValue = Math.trunc(num);
  return formatIndianNumber(intValue);
};

export const getDecimalValue = (num, upto = 2) => {
  return Number.isInteger(num) ? num?.toString() : num?.toFixed(upto);
};
export function DateComponent({ date }) {
  // Function to get the day with the correct ordinal suffix
  const getDayWithSuffix = (date) => {
    const day = date.date();
    if (day > 3 && day < 21) return `${day}th`; // Handle 4th-20th (special case)
    switch (day % 10) {
      case 1:
        return `${day}st`;
      case 2:
        return `${day}nd`;
      case 3:
        return `${day}rd`;
      default:
        return `${day}th`;
    }
  };
  const formattedDate =
    getDayWithSuffix(moment(date)) +
    ' ' +
    moment(date).format('MMM') +
    ', ' +
    moment(date).format('h:mm A');

  return formattedDate;
}

export const roundOffQuantityMT = (qty) => {
  return Number(parseFloat(qty || 0).toFixed(3));
};

export const areObjectsSame = (data, copyData) => {
  if (
    typeof data !== 'object' ||
    typeof copyData !== 'object' ||
    data === null ||
    copyData === null
  ) {
    return false;
  }
  const keys1 = Object.keys(data);
  const keys2 = Object.keys(copyData);
  if (keys1?.length !== keys2?.length) {
    return false;
  }

  return keys1?.every((key) => {
    return copyData?.hasOwnProperty(key) && data[key] === copyData[key];
  });
};

export const areArrayOfObjectsSame = (arrdata, copyArrData) => {
  if (!arrdata || !copyArrData) {
    return false;
  }
  if (arrdata?.length !== copyArrData?.length) {
    return false;
  }
  const areArraysEqual = arrdata?.every((objdata, index) => {
    const anotherobjdata = copyArrData[index];
    if (!anotherobjdata) return false;

    return Object.keys(objdata)?.every((key) => objdata[key] === anotherobjdata[key]);
  });

  return areArraysEqual ? true : false;
};

export const getCeilValue = (num) => {
  return Math.ceil(num * 10) / 10 >= Math.ceil(num) - 0.1
    ? Math.ceil(num)
    : Math.ceil(num * 10) / 10;
};

export function toCapitalizedLabel(input) {
  if (typeof input !== 'string') {
    if (input == null) return '';
    input = String(input);
  }

  return input
    ?.split(/[_-]+/)
    .map((word) =>
      word.length > 0 ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : ''
    )
    .join(' ');
}

export function formatDates(tempValue) {
  const [start, end] = tempValue;
  if (start) {
    start.setHour(0);
    start.setMinute(0);
    start.setSecond(0);
    start.setMillisecond(0);
  }
  if (end) {
    end?.setHour(23);
    end?.setMinute(59);
    end?.setSecond(59);
    end?.setMillisecond(999);
  }
  return [start, end];
}

export function formatDateUsingMoment(tempValue) {
  if (!Array.isArray(tempValue) || tempValue.length < 2) {
    return [null, null];
  }

  const [startRaw, endRaw] = tempValue;

  const start = moment(startRaw);
  const end = moment(endRaw);

  if (!start.isValid() || !end.isValid()) {
    return [null, null];
  }

  const formattedStart = start.startOf('day');
  const formattedEnd = end.endOf('day');

  return [formattedStart, formattedEnd];
}

export const getTraceabilityText = (val) => {
  return val === true || val === 'true' ? 'Yes' : val === false || val === 'false' ? 'No' : 'NA';
};

export const getFlooredValue = (value, comparedValue, isconvertToMT = true) => {
  const firstValue = value || 0;
  const finalValue = isconvertToMT
    ? Number(getDecimalValue(convertToMT(firstValue), 3))
    : Number(getDecimalValue(firstValue, 3));
  if (finalValue < 0) {
    return 0;
  }
  const minDigits = !Number.isInteger(finalValue) && finalValue < 1 && finalValue !== 0 ? 3 : 0;
  const anotherValue = comparedValue || finalValue;
  const formattedValue = anotherValue >= 1 ? Math.floor(finalValue) : finalValue;
  return formatIndianNumber(formattedValue, minDigits);
};

export const handleKeyDownForNumInput = (event) => {
  const invalidCharecters = ['-', '+', 'e'];
  if (invalidCharecters.includes(event?.key)) {
    event.preventDefault();
  }
};

export const getParsedUniqGSTINs = (resp) => {
  const result = [];
  const seenGstin = new Set();
  const seenNoGstin = new Set();
  const dataArray = Array.isArray(resp?.data) ? resp.data : [];

  for (const item of dataArray) {
    const addresses = safeJsonParse(item?.registeredAddresses) || [];
    for (const addr of addresses) {
      if (!addr) continue;
      const gstin = addr.gstin?.trim();
      if (gstin) {
        if (!seenGstin.has(gstin)) {
          seenGstin.add(gstin);
          result.push(addr);
        }
      } else {
        const key = JSON.stringify(addr);
        if (!seenNoGstin.has(key)) {
          seenNoGstin.add(key);
          result.push(addr);
        }
      }
    }
  }

  return result;
};
